import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';

import SubscribeForm from '../../common/forms/SubscribeForm';

import { LogoBlack } from '../../common/icons/Logos';

import ContactsInfo from '../../common/footer/ContactsInfo';
import AddressInfo from '../../common/footer/AddressInfo';

const Footer = props => {
  return (
    <>
      <div className={classnames('tutorium-footer', { 'is-secondary': !props.isPrimary })}>
        <div className="tutorium-container">
          <div className="tutorium-footer-content">
            <div>
              <LogoBlack />
              <ContactsInfo />
            </div>
            <div className="py-15px">
              <p className="tutorium-text has-text-centered">
                <HashLink to="/#start-screen-container-id" className="tutorium-footer-link" smooth>
                  Main
                </HashLink>
                <HashLink to="/#info-screen-container-id" className="tutorium-footer-link pl-40px" smooth>
                  About
                </HashLink>
                <Link to="/courses" className="tutorium-footer-link pl-40px">
                  Courses
                </Link>
                <HashLink to="/#faq-screen-container-id" className="tutorium-footer-link pl-40px" smooth>
                  FAQ
                </HashLink>
              </p>
            </div>
            <SubscribeForm isWhiteBackground={!props.isPrimary} />
          </div>
          <AddressInfo />
        </div>
      </div>
    </>
  );
};

Footer.propTypes = {
  isPrimary: PropTypes.bool,
};

export default Footer;
